import fetchData from "@/utils/fetchData";

const TOURS = ["initial", "result", "context", "questions", "style"];

// Completed tours are remembered in the browser too, so they don't reappear for
// visitors who aren't logged in
function storedTours() {
  try {
    const tours = JSON.parse(localStorage.getItem("completedTours") || "[]");
    return Array.isArray(tours) ? tours.filter((t) => TOURS.includes(t)) : [];
  } catch {
    return [];
  }
}

const initiallyCompleted = storedTours();

export default {
  name: "tours",
  namespaced: true,
  state: {
    showInitialTour: !initiallyCompleted.includes("initial"),
    showResultTour: !initiallyCompleted.includes("result"),
    showContextTour: !initiallyCompleted.includes("context"),
    showQuestionsTour: !initiallyCompleted.includes("questions"),
    showStyleTour: !initiallyCompleted.includes("style"),
    completedTours: initiallyCompleted,
  },
  mutations: {
    SET_SHOW_INITIAL_TOUR(state, payload) {
      state.showInitialTour = payload;
    },
    SET_SHOW_RESULT_TOUR(state, payload) {
      state.showResultTour = payload;
    },
    SET_SHOW_CONTEXT_TOUR(state, payload) {
      state.showContextTour = payload;
    },
    SET_SHOW_QUESTIONS_TOUR(state, payload) {
      state.showQuestionsTour = payload;
    },
    SET_SHOW_STYLE_TOUR(state, payload) {
      state.showStyleTour = payload;
    },
    SET_COMPLETED_TOURS(state, payload) {
      state.completedTours = [...new Set(payload)];
      localStorage.setItem(
        "completedTours",
        JSON.stringify(state.completedTours)
      );
    },
  },
  actions: {
    applyCompleted({ commit }, tours) {
      commit("SET_SHOW_INITIAL_TOUR", !tours.includes("initial"));
      commit("SET_SHOW_RESULT_TOUR", !tours.includes("result"));
      commit("SET_SHOW_CONTEXT_TOUR", !tours.includes("context"));
      commit("SET_SHOW_QUESTIONS_TOUR", !tours.includes("questions"));
      commit("SET_SHOW_STYLE_TOUR", !tours.includes("style"));
      commit("SET_COMPLETED_TOURS", tours);
    },
    async fetchTours({ dispatch, state }) {
      const { response } = await fetchData(
        "user/getTours",
        {},
        false,
        false,
        false
      );
      if (response.status !== 201 || !Array.isArray(response.result?.tours)) {
        return;
      }
      const tours = [...state.completedTours, ...response.result.tours];
      dispatch("applyCompleted", tours);
      // Share tours finished before logging in with the account
      if (tours.length > response.result.tours.length) {
        dispatch("saveTours");
      }
    },
    saveTours({ rootState, state }) {
      if (!rootState.auth.loggedIn) return;
      fetchData(
        "user/setTours",
        { tours: [...new Set(state.completedTours)] },
        false,
        false,
        false
      );
    },
    cancelTours({ dispatch }) {
      dispatch("applyCompleted", TOURS);
      dispatch("saveTours");
    },
    complete({ commit, dispatch, state }, tour) {
      commit("SET_COMPLETED_TOURS", [...state.completedTours, tour]);
      dispatch("saveTours");
    },
    unsetInitialTour({ commit }) {
      commit("SET_SHOW_INITIAL_TOUR", true);
    },
    completeInitialTour({ commit, dispatch }) {
      commit("SET_SHOW_INITIAL_TOUR", false);
      dispatch("complete", "initial");
    },
    unsetResultTour({ commit }) {
      commit("SET_SHOW_RESULT_TOUR", true);
    },
    completeResultTour({ commit, dispatch }) {
      commit("SET_SHOW_RESULT_TOUR", false);
      dispatch("complete", "result");
    },
    unsetContextTour({ commit }) {
      commit("SET_SHOW_CONTEXT_TOUR", true);
    },
    completeContextTour({ commit, dispatch }) {
      commit("SET_SHOW_CONTEXT_TOUR", false);
      dispatch("complete", "context");
    },
    unsetQuestionsTour({ commit }) {
      commit("SET_SHOW_QUESTIONS_TOUR", true);
    },
    completeQuestionsTour({ commit, dispatch }) {
      commit("SET_SHOW_QUESTIONS_TOUR", false);
      dispatch("complete", "questions");
    },
    unsetStyleTour({ commit }) {
      commit("SET_SHOW_STYLE_TOUR", true);
    },
    completeStyleTour({ commit, dispatch }) {
      commit("SET_SHOW_STYLE_TOUR", false);
      dispatch("complete", "style");
    },
  },
  modules: {},
  getters: {},
};
